import { render, staticRenderFns } from "./DownloadItem.vue?vue&type=template&id=5a4b29fe&scoped=true&"
import script from "./DownloadItem.vue?vue&type=script&lang=js&"
export * from "./DownloadItem.vue?vue&type=script&lang=js&"
import style0 from "./DownloadItem.vue?vue&type=style&index=0&id=5a4b29fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b29fe",
  null
  
)

export default component.exports